import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'org'
const plural = 'orgs'
const single = 'org'


const api = new ApiCore({
	index: true,
	findOne: false,
	create: false,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})


api.index = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}`, params)
		.then(handleResponse)
		.catch(handleError);
}

// api.delete = (id) => {
// 	return axios
// 		.delete(`${apiProvider.BASE_URL}/${url}/${id}`)
// 		.then(handleResponse)
// 		.catch(handleError);
// }

api.updateStatusMakerChecker = (orgId, params) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${orgId}/makerCheckerStatusUpdate`, params)
		.then(handleResponse)
		.catch(handleError);
}

api.getPendingMakerCheckerTransactions = (orgId) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${orgId}/pendingMakerCheckerTransactions`)
		.then(handleResponse)
		.catch(handleError);
}

api.updateSharePrincipalStatus = (params) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/update-principal-sharing`, params)
		.then(handleResponse)
		.catch(handleError);
}

export default api
